"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CarvanaHeaderContext = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var CarvanaHeaderContext = _react.default.createContext();

exports.CarvanaHeaderContext = CarvanaHeaderContext;

var CarvanaHeaderProvider = function (_React$Component) {
  _inherits(CarvanaHeaderProvider, _React$Component);

  function CarvanaHeaderProvider() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, CarvanaHeaderProvider);

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(CarvanaHeaderProvider)).call.apply(_getPrototypeOf2, [this].concat(_args)));
    _this.state = {
      accountModal: {
        shouldShowAccountModal: false
      },
      shouldRefreshProfile: false,
      chatHeaderContext: {
        showChat: false
      }
    };

    _this.openAccountModal = function (args) {
      var accountModal = _this.state.accountModal;
      var shouldShowAccountModal = accountModal.shouldShowAccountModal;

      _this.setState({
        accountModal: _objectSpread({}, args, {
          shouldShowAccountModal: !shouldShowAccountModal
        })
      });
    };

    _this.closeAccountModal = function () {
      _this.setState({
        accountModal: {
          shouldShowAccountModal: false
        }
      });
    };

    _this.refreshProfile = function () {
      var shouldRefreshProfile = _this.state.shouldRefreshProfile;

      _this.setState({
        shouldRefreshProfile: !shouldRefreshProfile
      });
    };

    _this.openChat = function (args) {
      var chatHeaderContext = _this.state.chatHeaderContext;
      var showChat = chatHeaderContext.showChat;

      _this.setState({
        chatHeaderContext: _objectSpread({}, args, {
          showChat: !showChat
        })
      });
    };

    return _this;
  }

  _createClass(CarvanaHeaderProvider, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      var state = this.state;

      var providerState = _objectSpread({}, state, {
        accountModal: _objectSpread({}, state.accountModal, {
          closeAccountModal: this.closeAccountModal
        }),
        openAccountModal: this.openAccountModal,
        closeAccountModal: this.closeAccountModal,
        refreshProfile: this.refreshProfile,
        openChat: this.openChat
      });

      return _react.default.createElement(CarvanaHeaderContext.Provider, {
        value: providerState,
        "data-qa": "carvana-header-provider"
      }, children);
    }
  }]);

  return CarvanaHeaderProvider;
}(_react.default.Component);

exports.default = CarvanaHeaderProvider;